/**
 * Key-value map from `data-av-field` → display value (for persisting `ui_state`).
 */
export function extractClarificationFieldValues(root: HTMLElement): Record<string, string> {
  const out: Record<string, string> = {};
  root
    .querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
      'input[data-av-field], select[data-av-field], textarea[data-av-field]'
    )
    .forEach((el) => {
      const key = el.getAttribute('data-av-field')?.trim();
      if (!key) return;
      const optional = el.hasAttribute('data-av-optional');

      let value = '';
      if (el instanceof HTMLSelectElement) {
        value = el.value.trim();
      } else if (el instanceof HTMLTextAreaElement) {
        value = el.value.trim();
      } else if (el.type === 'checkbox') {
        value = el.checked ? 'Yes' : 'No';
      } else {
        value = el.value.trim();
      }

      if (!value && optional) return;
      out[key] = value;
    });
  return out;
}

/**
 * Builds the user message sent when the merchant completes an LLM-rendered
 * clarification block (`data-av-clarification`). Plain lines only — no markdown
 * headers — so the composer input stays readable.
 *
 * `data-av-preamble` on the root is for on-screen copy only; it is not sent.
 */
export function composeClarificationMessage(root: HTMLElement): string {
  const fields = root.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    'input[data-av-field], select[data-av-field], textarea[data-av-field]'
  );

  const lines: string[] = [];

  fields.forEach((el) => {
    const label = el.getAttribute('data-av-label')?.trim() || el.getAttribute('data-av-field') || 'Field';
    const optional = el.hasAttribute('data-av-optional');

    let value = '';
    if (el instanceof HTMLSelectElement) {
      value = el.value.trim();
    } else if (el instanceof HTMLTextAreaElement) {
      value = el.value.trim();
    } else if (el.type === 'checkbox') {
      value = el.checked ? 'Yes' : 'No';
    } else {
      value = el.value.trim();
    }

    if (!value && optional) return;

    lines.push(`${label}: ${value || '—'}`);
  });

  return lines.join('\n');
}
